// paypal.js

import { paypal } from '../actions';

const initialState = {
  status: paypal.types.READY,
  creditsPackage: { name: null, price: null, sku: null },
  buttonClickMsg: ''
};

const paypal_reducers = (state, action) => {
  if (typeof state === 'undefined') return initialState;
  switch (action.type) {
    case paypal.types.READY:
      return { ...state, ...initialState };
    case paypal.types.PAYMENT_PENDING:
    case paypal.types.COMPLETE:
      return { ...state, status: action.type };
    case paypal.types.FAILED:
      return { ...state, status: action.type, error: action.error };
    case paypal.types.SET_CREDITS:
      return { ...state, creditsPackage: action.creditsPackage };
    case paypal.types.BUTTON_CLICK:
      return { ...state, buttonClickMsg: action.msg };
    default:
      return state;
  }
};

export default paypal_reducers;



// WEBPACK FOOTER //
// ./src/store/reducers/paypal.js